import React, { FC } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

const Login = React.lazy(() => import("../../../login"));
const Auth = React.lazy(() => import("../../../auth"));
const Logout = React.lazy(() => import("../../../logout"));
const AppPortal = React.lazy(() => import("../../../app-portal"));
const PreScreening = React.lazy(() => import("../../../prescreening"));
const UserUpload = React.lazy(() => import("../../../user-upload"));
const SoftwareTokenSetup = React.lazy(
  () => import("../../../profile-setup/component/software-token"),
);
const DeviceManagement = React.lazy(
  () => import("../../../profile-setup/component/device-management"),
);

const UserManagement = React.lazy(
  () => import("../../../profile-setup/component/user-management"),
);

const SSWEPolicy = React.lazy(
  () => import("../../../e-policy/ssw/components/search-policy"),
);
const SSWEPolicyMyHistory = React.lazy(
  () => import("../../../e-policy/ssw/components/my-history"),
);
const SSWEPolicyPolicyHistory = React.lazy(
  () => import("../../../e-policy/ssw/components/policy-history"),
);
const SSWSaleReport = React.lazy(
  () => import("../../../sale-report/ssw/components"),
);
const TGSaleReport = React.lazy(
  () => import("../../../sale-report/tg/components"),
);

const AppRoute: FC = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<AppPortal />} />
      <Route path="/login" element={<Login />} />
      <Route path="/oauth/authorize" element={<Auth version={1} />} />
      <Route path="/oauth2/authorize" element={<Auth version={2} />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/prescreen" element={<PreScreening />} />
      <Route path="/user-upload" element={<UserUpload />} />
      <Route path="/app-portal" element={<AppPortal />} />
      <Route path="/profile-setup" element={<UserManagement />} />
      <Route
        path="/profile-setup/software-token-setup"
        element={<SoftwareTokenSetup />}
      />
      <Route
        path="/profile-setup/device-management"
        element={<DeviceManagement />}
      />
      <Route
        path="/profile-setup/user-management"
        element={<UserManagement />}
      />
      <Route path="/ssw" element={<Login />} />
      <Route path="/ssw/app-portal" element={<AppPortal />} />
      <Route path="/ssw/profile-setup" element={<UserManagement />} />
      <Route
        path="/ssw/profile-setup/software-token-setup"
        element={<SoftwareTokenSetup />}
      />
      <Route
        path="/ssw/profile-setup/device-management"
        element={<DeviceManagement />}
      />
      <Route
        path="/ssw/profile-setup/user-management"
        element={<UserManagement />}
      />
      <Route path="/ssw/e-policy/search-policy" element={<SSWEPolicy />} />
      <Route
        path="/ssw/e-policy/my-send-history"
        element={<SSWEPolicyMyHistory />}
      />
      <Route
        path="/ssw/e-policy/policy-history"
        element={<SSWEPolicyPolicyHistory />}
      />
      <Route path="/ssw/sale-report" element={<SSWSaleReport />} />
      <Route path="/tg" element={<Login />} />
      <Route path="/tg/app-portal" element={<AppPortal />} />
      <Route path="/tg/profile-setup" element={<UserManagement />} />
      <Route
        path="/tg/profile-setup/software-token-setup"
        element={<SoftwareTokenSetup />}
      />
      <Route
        path="/tg/profile-setup/device-management"
        element={<DeviceManagement />}
      />
      <Route
        path="/tg/profile-setup/user-management"
        element={<UserManagement />}
      />
      <Route path="/tg/sale-report" element={<TGSaleReport />} />
    </Routes>
  </BrowserRouter>
);

export default AppRoute;
